import React, { useMemo } from 'react'

import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

import { ShowUpTextProps } from './types'

export const ShowUpText = ({ fullScreen = false }: ShowUpTextProps) => {
  const gradientTextStyles = useMemo(() => {
    return {
      background: '-webkit-linear-gradient(180deg, #FF3E6C 2.53%, #4071EB 97.75%)',
      webkitBackgroundClip: 'text',
      webkitTextFillColor: 'transparent',
    }
  }, [])

  const showTextStyles = useMemo(() => {
    return {
      marginTop: fullScreen ? -40 : undefined,
      marginBottom: fullScreen ? -40 : undefined,
      fontSize: fullScreen ? 138 : 30,
      ...gradientTextStyles,
    }
  }, [fullScreen, gradientTextStyles])

  const upTextStyles = useMemo(() => {
    return {
      fontSize: fullScreen ? 280 : 30,
      marginTop: fullScreen ? -140 : undefined,
      marginBottom: fullScreen ? -20 : undefined,
      ...gradientTextStyles,
    }
  }, [fullScreen, gradientTextStyles])

  return (
    <>
      {fullScreen ? (
        <Box align='center' justifyContent='center'>
          <Text testID='ShowText' color='v2secondary' bold align='center' style={showTextStyles}>
            show
          </Text>
          <Text testID='UpText' color='v2secondary' bold align='center' style={upTextStyles}>
            up
          </Text>
        </Box>
      ) : (
        <Text testID='ShowText' color='v2secondary' bold align='center' style={showTextStyles}>
          show up
        </Text>
      )}
    </>
  )
}
